export function evidenceHighlightSquares(
  item: { highlightFen?: string; highlightSquares?: readonly string[] } | null,
  displayFen: string,
): string[] {
  if (item?.highlightFen !== displayFen) return [];
  return [...new Set(item.highlightSquares?.filter((square) => /^[a-h][1-8]$/.test(square)))];
}
